import React, { useState } from "react";
import { FetchAPIContext } from "../../context/FetchAPIContext";
import { API, BEARER } from "../../constant";
import { useEffect } from "react";
import { getToken } from "../../helpers";
import Loading from "../Hooks/Loading";

    
    const APIProvider = ({ children }) => {
      const [apiUrl, setApiUrl] = useState();
      const [isLoading, setIsLoading] = useState();
      const [apiData, setAPIData] = useState();

      // console.log(apiUrl);
      // console.log(apiData);
    
      const authToken = getToken();
    
      const fetchAPI = async (token, url) => {
        setIsLoading(true);
        try {
          const response = await fetch(url, {
            headers: { Authorization: `${BEARER} ${token}` },
          });
          const data = await response.json();
    
          setAPIData(data);
          // console.log(data);
        } catch (error) {
          console.error(error);
          
        } finally {
          setIsLoading(false);
        }
      };
    
      useEffect(() => {
        if (authToken && apiUrl) {
            fetchAPI(authToken, apiUrl);
        }
      }, [authToken, apiUrl]);
      // console.log(apiData);
      
      if(isLoading)
        return <Loading/>
      else
       
          return (
          <FetchAPIContext.Provider
            value={{ data: apiData, isLoading, setApiUrl }}
          >
            {children}
          </FetchAPIContext.Provider>
          );
      };
    
    export default APIProvider;